'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherCheckCircle, FeatherMinusCircle, FeatherX } from '@subframe/core';
import { useRouter } from 'next/navigation';
import { useEffect, useRef } from 'react';
import { listSectorsSummary, selectSectorsSummary } from '@/features/compartilhamento/store';
import { listarMembros, selectEscritorioMembros, selectEscritorioMembrosCarregadoPara } from '@/features/escritorio/store/membros';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { carregarPreferenciasUi, concluirChecklistSetores, dispensarChecklistConfiguracao, selectChecklistDispensado, selectChecklistSetoresConcluido } from '../store';
import type { ChecklistConfiguracaoProps } from '../types';
const TOTAL_ETAPAS = 4;

// TODO: trocar as listagens de domínio por contadores servidos pelo próprio
// GET /me/preferencias-ui (ou endpoint de onboarding) quando o backend expor.
export const ChecklistConfiguracao = t0 => {
  const $ = _c(57);
  const {
    escritorioId,
    isCollapsed,
    onNavigate
  } = t0;
  const dispatch = useAppDispatch();
  const router = useRouter();
  const sectors = useAppSelector(selectSectorsSummary);
  const membros = useAppSelector(selectEscritorioMembros);
  const membrosCarregadosPara = useAppSelector(selectEscritorioMembrosCarregadoPara);
  const dispensado = useAppSelector(selectChecklistDispensado);
  const setoresVisitados = useAppSelector(selectChecklistSetoresConcluido);
  const buscouParaRef = useRef(null);
  let t1;
  let t2;
  if ($[0] !== dispatch || $[1] !== dispensado) {
    t1 = () => {
      if (dispensado === null) {
        dispatch(carregarPreferenciasUi());
      }
    };
    t2 = [dispatch, dispensado];
    $[0] = dispatch;
    $[1] = dispensado;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[4] !== dispatch || $[5] !== dispensado || $[6] !== escritorioId || $[7] !== membrosCarregadosPara || $[8] !== sectors.length) {
    t3 = () => {
      if (!escritorioId || dispensado !== false) {
        return;
      }
      if (buscouParaRef.current === escritorioId) {
        return;
      }
      buscouParaRef.current = escritorioId;
      if (sectors.length === 0) {
        dispatch(listSectorsSummary());
      }
      if (membrosCarregadosPara !== escritorioId) {
        dispatch(listarMembros({
          escritorioId,
          filters: {
            ativo: true
          }
        }));
      }
    };
    t4 = [dispatch, escritorioId, dispensado, sectors.length, membrosCarregadosPara];
    $[4] = dispatch;
    $[5] = dispensado;
    $[6] = escritorioId;
    $[7] = membrosCarregadosPara;
    $[8] = sectors.length;
    $[9] = t3;
    $[10] = t4;
  } else {
    t3 = $[9];
    t4 = $[10];
  }
  useEffect(t3, t4);
  const setoresOk = sectors.length >= 1 || setoresVisitados;
  let t5;
  if ($[11] !== membros) {
    t5 = membros.filter(_temp);
    $[11] = membros;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const equipeOk = t5.length >= 2;
  if (isCollapsed || dispensado !== false || setoresOk && equipeOk) {
    return null;
  }
  let t6;
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      label: "Cadastro conclu\xEDdo",
      ok: true
    };
    t7 = {
      label: "Pagamento confirmado",
      ok: true
    };
    $[13] = t6;
    $[14] = t7;
  } else {
    t6 = $[13];
    t7 = $[14];
  }
  let t8;
  if ($[15] !== setoresOk) {
    t8 = {
      label: "Configure os setores",
      ok: setoresOk
    };
    $[15] = setoresOk;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== equipeOk) {
    t9 = {
      label: "Configure sua equipe",
      ok: equipeOk
    };
    $[17] = equipeOk;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t8 || $[20] !== t9) {
    t10 = [t6, t7, t8, t9];
    $[19] = t8;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  const etapas = t10;
  let t11;
  if ($[22] !== etapas) {
    t11 = etapas.filter(_temp2);
    $[22] = etapas;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  const concluidas = t11.length;
  const proximaEtapa = setoresOk ? "Configure sua equipe" : "Configure os setores";
  let t12;
  if ($[24] !== dispatch) {
    t12 = () => dispatch(dispensarChecklistConfiguracao());
    $[24] = dispatch;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  const dispensar = t12;
  let t13;
  if ($[26] !== dispatch || $[27] !== onNavigate || $[28] !== router || $[29] !== setoresOk) {
    t13 = () => {
      if (!setoresOk) {
        dispatch(concluirChecklistSetores());
        router.push("/configuracoes/organizacao?tab=setores");
        onNavigate?.();
        return;
      }
      dispatch(dispensarChecklistConfiguracao());
      router.push("/configuracoes/organizacao?tab=usuarios");
      onNavigate?.();
    };
    $[26] = dispatch;
    $[27] = onNavigate;
    $[28] = router;
    $[29] = setoresOk;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  const irParaProximaEtapa = t13;
  let t14;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <span className="text-heading-dark flex-1 text-sm font-semibold">Complete sua conta</span>;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <FeatherX className="size-5" />;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== dispensar) {
    t16 = <div className="flex items-start gap-2">{t14}<button type="button" aria-label="Dispensar checklist" onClick={dispensar} className="text-neutral-400 hover:text-neutral-600">{t15}</button></div>;
    $[33] = dispensar;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] !== concluidas) {
    t17 = <span className="text-sm text-neutral-600">{concluidas}/{TOTAL_ETAPAS} etapas concluídas</span>;
    $[35] = concluidas;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== t16 || $[38] !== t17) {
    t18 = <div className="flex flex-col gap-1">{t16}{t17}</div>;
    $[37] = t16;
    $[38] = t17;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  const t19 = `${concluidas / TOTAL_ETAPAS * 100}%`;
  let t20;
  if ($[40] !== t19) {
    t20 = <div className="bg-brand-700 h-2 rounded-full" style={{
      width: t19
    }} />;
    $[40] = t19;
    $[41] = t20;
  } else {
    t20 = $[41];
  }
  let t21;
  if ($[42] !== concluidas || $[43] !== t20) {
    t21 = <div role="progressbar" aria-valuemin={0} aria-valuemax={TOTAL_ETAPAS} aria-valuenow={concluidas} className="h-2 w-full rounded-full bg-neutral-200">{t20}</div>;
    $[42] = concluidas;
    $[43] = t20;
    $[44] = t21;
  } else {
    t21 = $[44];
  }
  let t22;
  if ($[45] !== t18 || $[46] !== t21) {
    t22 = <div className="flex flex-col gap-3">{t18}{t21}</div>;
    $[45] = t18;
    $[46] = t21;
    $[47] = t22;
  } else {
    t22 = $[47];
  }
  let t23;
  if ($[48] !== etapas) {
    t23 = <div className="flex flex-col gap-2">{etapas.map(_temp3)}</div>;
    $[48] = etapas;
    $[49] = t23;
  } else {
    t23 = $[49];
  }
  let t24;
  if ($[50] !== irParaProximaEtapa || $[51] !== proximaEtapa) {
    t24 = <button type="button" onClick={irParaProximaEtapa} className="bg-brand-700 flex h-9 w-full items-center justify-center rounded-lg px-3 text-sm font-semibold text-white shadow-[0px_1px_2px_0px_rgba(24,29,39,0.08)] transition-opacity hover:opacity-90">{proximaEtapa}</button>;
    $[50] = irParaProximaEtapa;
    $[51] = proximaEtapa;
    $[52] = t24;
  } else {
    t24 = $[52];
  }
  let t25;
  if ($[53] !== t22 || $[54] !== t23 || $[55] !== t24) {
    t25 = <div className="mx-3 mb-2 flex flex-col gap-4 rounded-2xl border border-solid border-neutral-200 bg-neutral-50 p-5">{t22}{t23}{t24}</div>;
    $[53] = t22;
    $[54] = t23;
    $[55] = t24;
    $[56] = t25;
  } else {
    t25 = $[56];
  }
  return t25;
};
function _temp(membro) {
  return membro.ativo;
}
function _temp2(etapa) {
  return etapa.ok;
}
function _temp3(etapa_0) {
  return <div key={etapa_0.label} className="flex items-center gap-2">{etapa_0.ok ? <FeatherCheckCircle className="text-success-600 size-5 flex-none" /> : <FeatherMinusCircle className="size-5 flex-none text-neutral-400" />}<span className="flex-1 text-sm font-medium text-neutral-600">{etapa_0.label}</span></div>;
}